import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=374aa6fb&scoped=true"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"
import style0 from "./userInfo.vue?vue&type=style&index=0&id=374aa6fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374aa6fb",
  null
  
)

export default component.exports